import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, StarHalfIcon } from 'lucide-react';
import { TESTIMONIALS } from './salesData';

/** Estrellas llenas + media estrella, con el puntaje accesible como texto. */
function Rating({
  value
}: {
  value: number;
}) {
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.5;
  return <div className="flex items-center gap-0.5" role="img" aria-label={`${value} de 5 estrellas`} data-id="element-246" data-mp="1qzt2ypkl3q59">
      {Array.from({
      length: full
    }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-champagne text-champagne" aria-hidden data-id="element-247" data-mp="1i17lyyurgj6l" data-mpi={i} />)}
      {hasHalf && <StarHalfIcon className="h-3.5 w-3.5 fill-champagne text-champagne" aria-hidden data-id="element-248" data-mp="142hm5bgk45ej" />}
    </div>;
}
export function TestimonialsSection() {
  return <section id="opiniones" className="bg-white py-11 sm:py-14" data-id="element-249" data-mp="2yeo02i0u50aj">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-250" data-mp="2yd37uz1zttfu">
        <div className="text-center" data-id="element-251" data-mp="32frbmsbuoa5y">
          <h2 className="mx-auto max-w-[22ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-252" data-mp="32eolwnq9kdrm">
            Lo que dicen quienes ya <span className="text-gold-deep" data-id="element-253" data-mp="2q1yd0abvylku">empezaron</span>
          </h2>
        </div>

        <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-254" data-mp="34q2ooucitwu4">
          {TESTIMONIALS.map((t, i) => <motion.li key={t.author} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 3) * 0.04
        }} className="flex h-full flex-col rounded-xl border border-stone bg-cream px-4 py-3.5" data-id="element-255" data-mp="2ztly7thun6dv" data-mpi={i}>
              <Rating value={t.rating} data-id="element-256" data-mp="2h0i4670pyriq" />
              <h3 className="mt-2 font-display text-[0.86rem] font-bold leading-tight text-charcoal" data-id="element-257" data-mp="1af3q6rkys0f">
                “{t.title}”
              </h3>
              <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-taupe" data-id="element-258" data-mp="3sggfyina7rnn">{t.quote}</p>
              <p className="mt-auto pt-2.5 font-display text-[0.72rem] font-bold uppercase tracking-[0.06em] text-gold-deep" data-id="element-259" data-mp="3e936luzolbh">
                {t.author}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}